import React, { useState } from 'react';
import { Card, CardContent, Typography, Avatar, Box, IconButton, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TimelineConnector, TimelineDot, TimelineItem, TimelineSeparator } from '@material-ui/lab';
import { Button, ButtonBase, Divider, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';


const useStyles = makeStyles({
    card: {
        display: 'flex',
        marginBottom: '20px',
        justifyContent: 'center',
        width: '255px',
        height: '42px',
        marginTop: '10px',
        borderRadius: '5px',
        marginLeft: '50px',
    },
    cardSale: {
        display: 'flex',
        marginBottom: '20px',
        justifyContent: 'center',
        width: '255px',
        height: '42px',
        marginLeft: '56%',
        marginTop: '10px',
        borderRadius: '5px'
    },
    content: {
        flex: '1 0 auto',
    },
    avatar: {
        alignSelf: 'center',
    },
    left: {
        marginRight: 'auto',
        order: 2, // Mover para a direita
    },
    right: {
        marginLeft: 'auto',
        order: 2, // Mover para a esquerda
    },
    separator: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '-96px'
    }
});

const Timeline = ({
    data,
    index,
    handleMenuOpen,
    row,
    updateTimsheet,
    handleOpenActionsModal,
    handleOpenModalUpdate,
    openModalTimesheetDelete,
    timesheetRow,
    setType,
    setRow,
    setTimesheetRow,
    succesMessage,
    setOpenHistory,
    dataRow,
    setMenuTimesheet,
    menuTimesheet,
    loadingHistory,
    startLoading,
    dataReportGroup,
}) => {
    const classes = useStyles();

    // const [menuTimesheet, setMenuTimesheet] = useState(false)
    const open = Boolean(menuTimesheet);
    const openRemoved = Boolean(dataReportGroup.menuTimesheetRemoved);

    const handleOpenMenu = (event) => {
        setMenuTimesheet(event.currentTarget)
        // console.log(data.timesheetRow)
        setTimesheetRow(data.timesheetRow)
        setRow(row)
        setType(data.type == 'Entrada' || data.type == 'I' ? "I" : "O")
    }

    const handleOpenMenuRemoved = async (event) => {
        try {
            dataReportGroup.setMenuTimesheetRemoved(event.currentTarget)
            await setTimesheetRow(data.timesheetRow)
            // console.log(data)
        } catch (error) {
            console.log(error)
        }
    }



    const timesheetUpdate = () => {
        updateTimsheet();
        setMenuTimesheet(false)
        startLoading('Alterando')
        // setOpenHistory(false)
    }
    const openMenuEdit = () => {
        handleOpenModalUpdate();
        // setOpenHistory(false)
    }
    const openMenuRemoved = () => {
        openModalTimesheetDelete();
        // setOpenHistory(false)
    }



    function getFirstNameAndLastName(authorString) {
        let parts = authorString.split(' ');

        let firstName = parts[0];
        let lastName = parts[1];

        return firstName
    }

    let ultimoElemento = dataRow.length - 1;
    return (
        <>

            <Card className={data.type === 'Entrada' || data.type === 'I' ? classes.card : classes.cardSale}>
                {
                    loadingHistory.timeclockId == data.timesheetRow?.timeclockId && loadingHistory.isLoading ?

                        <Box style={{ display: 'flex' }}>
                            <Typography style={{ marginTop: '8px' }}>
                                {loadingHistory.message}
                            </Typography>
                            <CircularProgress size={30} style={{ marginLeft: '20px', marginTop: '4px' }} />
                        </Box>
                        :

                        (

                            <Box
                                display="flex"
                                alignItems='center'
                                justifyContent='space-between'
                                className={data.type === 'Entrada' || data.type === 'I' ? classes.left : classes.right}
                                position="relative"
                            >
                                {
                                    data.type === 'Entrada' || data.type === 'I' ?
                                        <Box bgcolor={data.isremoved ? "#d7d7d7" : "green"} width="4px" height="35px" marginLeft="15px" borderRadius="30px" position="absolute" />
                                        :
                                        <IconButton
                                            onClick={(event) => data.isremoved ? handleOpenMenuRemoved(event) : handleOpenMenu(event)}
                                            // disabled={data.isremoved}
                                            style={{ position: 'absolute', marginLeft: '-100px' }}
                                        >
                                            <MoreVertIcon style={{ color: 'gray', fontSize: '25px' }} />
                                        </IconButton>
                                }
                                <Typography
                                    style={{
                                        // marginLeft: data.type === 'Entrada' || data.type === 'I' ? '25px' : '0px',
                                        left: data.type === 'Entrada' || data.type === 'I' ? '25px' : '-25px',
                                        textAlign: data.type === 'Entrada' || data.type === 'I' ? 'left' : 'right',
                                        display: 'flex',
                                        position: 'relative',
                                        justifyContent: 'space-between'
                                    }}
                                >
                                    {
                                        data.type === 'Entrada' || data.type === 'I' ?
                                            <Typography variant="h5" component="div" style={{ fontWeight: 'bold', fontFamily: 'Montserrat', color: data.isremoved ? "#d7d7d7" : '#454a52' }}>
                                                {data.event}
                                            </Typography>
                                            : null
                                    }
                                    <Box
                                        style={{
                                            left: '0px',
                                            right: '0px'
                                        }}
                                    >
                                        <Typography variant="body2" style={{
                                            color: data.isremoved ? "#b5b7bb" : '#0d1136',
                                            fontWeight: 'bold',
                                            fontFamily: 'Montserrat',
                                            fontSize: '11px',
                                            marginBottom: '-13px',
                                            marginTop: '5px',
                                            marginLeft: data.type === 'Entrada' || data.type === 'I' ? '4px' : '-4px'

                                        }}>
                                            {data.type === 'Entrada' || data.type === 'I' ? 'Entrada' : 'Saída'}
                                        </Typography>
                                        <Typography variant="caption" style={{
                                            color: '#a2adbc',
                                            whiteSpace: 'nowrap',
                                            fontFamily: 'Montserrat',
                                            fontSize: '9px',
                                            marginLeft: data.type === 'Entrada' || data.type === 'I' ? '4px' : '-4px'
                                        }}>
                                            {data.isremoved ? 'Removido pelo Gestor' : (getFirstNameAndLastName(data.timesheetAuthor) + ' (' + (data.isRemake ? 'Gestor)' : 'Funcionário)'))}
                                        </Typography>
                                    </Box>
                                    {
                                        data.type === 'Entrada' || data.type === 'I' ?
                                            null :
                                            <Typography variant="h5" component="div" style={{
                                                fontWeight: 'bold',
                                                fontFamily: 'Montserrat',
                                                right: data.type === 'Entrada' || data.type === 'I' ? '0px' : '-4px',
                                                color: data.isremoved ? "#d7d7d7" : '#454a52'
                                            }}>
                                                {data.event}
                                            </Typography>
                                    }
                                </Typography>
                                {
                                    data.type === 'Entrada' || data.type === 'I' ?
                                        <IconButton
                                            onClick={(event) => data.isremoved ? handleOpenMenuRemoved(event) : handleOpenMenu(event)}
                                            style={{ position: 'absolute', marginLeft: '180px' }}
                                        // disabled={data.isremoved}
                                        >
                                            <MoreVertIcon style={{ color: 'gray', fontSize: '25px' }} />
                                        </IconButton>
                                        :
                                        <Box bgcolor={data.isremoved ? "#d7d7d7" : "red"} width="4px" height="35px" borderRadius="25px" right="11px" position="absolute" />
                                }
                            </Box>
                        )
                }
            </Card>


            <div className={classes.separator}>
                <TimelineItem position="absolute" style={{ top: '0%', transform: 'translateY(50%)' }}>
                    <TimelineSeparator>
                        <TimelineDot style={{ backgroundColor: data.isremoved ? '#d7d7d7' : data.type === 'Entrada' || data.type === 'I' ? '#29892c' : '#ce353f', marginTop: '15px' }} />
                        {/* {ultimoElemento != index && <TimelineConnector style={{ marginTop: -8 }} />} */}
                        <TimelineConnector style={{ marginTop: -8 }} />
                    </TimelineSeparator>
                </TimelineItem>

            </div>
            <Menu
                id="simple-menu"
                anchorEl={menuTimesheet}
                keepMounted
                open={open}
                onClose={() => setMenuTimesheet(false)}
                PaperProps={{
                    style: {
                        border: '1px solid white', // Definindo a cor da borda como branca
                        borderColor: 'white',
                        backgroundColor: 'rgba(255, 255, 255, 0.95)', // Cor de fundo do menu
                        boxShadow: 'none'
                    },
                }}

            >
                <MenuItem onClick={handleOpenActionsModal}>Ver detalhes</MenuItem>
                <MenuItem onClick={openMenuEdit}>Editar ponto</MenuItem>
                <MenuItem onClick={timesheetUpdate}>Alterar para {timesheetRow ? timesheetRow.type == 'Entrada' ? 'saída' : 'entrada' : null}</MenuItem>
                <MenuItem onClick={openMenuRemoved}>Excluir</MenuItem>

            </Menu>
            <Menu
                id="simple-menu"
                anchorEl={dataReportGroup.menuTimesheetRemoved}
                keepMounted
                open={openRemoved}
                onClose={() => dataReportGroup.setMenuTimesheetRemoved(false)}
                PaperProps={{
                    style: {
                        border: '1px solid white', // Definindo a cor da borda como branca
                        borderColor: 'white',
                        backgroundColor: 'rgba(255, 255, 255, 0.95)', // Cor de fundo do menu
                        boxShadow: 'none'
                    },
                }}

            >
                <MenuItem onClick={dataReportGroup.updateRemovedTimesheet}>Reativar ponto</MenuItem>

            </Menu>

        </>
    );
};

const TimelineArray = ({
    dataRow,
    handleMenuOpen,
    row,
    updateTimsheet,
    handleOpenActionsModal,
    handleOpenModalUpdate,
    openModalTimesheetDelete,
    timesheetRow,
    setType,
    setRow,
    setTimesheetRow,
    succesMessage,
    setOpenHistory,
    setMenuTimesheet,
    menuTimesheet,
    loadingHistory,
    startLoading,
    setOpenAddPoint,
    handleOpenADDpoint,
    dataReportGroup
}) => (
    <div>
        {dataRow.map((data, index) => (
            <>
                <Timeline
                    data={data}
                    index={index}
                    handleMenuOpen={handleMenuOpen}
                    row={row}
                    updateTimsheet={updateTimsheet}
                    handleOpenActionsModal={handleOpenActionsModal}
                    handleOpenModalUpdate={handleOpenModalUpdate}
                    openModalTimesheetDelete={openModalTimesheetDelete}
                    timesheetRow={timesheetRow}
                    setType={setType}
                    setRow={setRow}
                    setTimesheetRow={setTimesheetRow}
                    succesMessage={succesMessage}
                    setOpenHistory={setOpenHistory}
                    dataRow={dataRow}
                    setMenuTimesheet={setMenuTimesheet}
                    menuTimesheet={menuTimesheet}
                    loadingHistory={loadingHistory}
                    startLoading={startLoading}
                    dataReportGroup={dataReportGroup}
                />
                {
                    dataRow.length - 1 == index ?
                        <>
                            <Card
                                style={dataRow.at(-1).type == 'Entrada' ? styles.right : styles.left}

                            >
                                <Button
                                    onClick={() => {
                                        handleOpenADDpoint();
                                        setOpenHistory(false);
                                    }}
                                    style={{
                                        color: '#b6b8bc'
                                    }}
                                >
                                    Adicionar ponto
                                </Button>
                            </Card>
                        </>
                        :
                        null
                }

            </>
        ))}
    </div>
);

export default TimelineArray;

const styles = {
    right: {
        display: 'flex',
        marginBottom: '20px',
        justifyContent: 'center',
        width: '255px',
        height: '42px',
        marginLeft: '56%',
        marginTop: '10px',
        borderRadius: '5px'
    },
    left: {
        display: 'flex',
        marginBottom: '20px',
        justifyContent: 'center',
        width: '255px',
        height: '42px',
        marginTop: '10px',
        borderRadius: '5px',
        marginLeft: '50px',
        alignItems: 'center'
    }
}
